import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
    Container, ScrollableContainer, Text
} from "../../../../../../components/index";
import { Bike } from "../../../../../../managers/Garage/index";
import {di} from "../../../../../../bottle";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import {InfoIcon} from "./InfoIcon";


// class definition
export class CosmeticList extends Component {

    static propTypes = {
        parts: PropTypes.array.isRequired,
        bike: PropTypes.instanceOf(Bike).isRequired,
        onSectionDetails: PropTypes.func,
        onPartToggled: PropTypes.func
    };

    static defaultProps = {
        onSectionDetails: section => undefined,
        onPartToggled: () => undefined
    };

    render() {

        // resolve input
        const { parts, bike, onSectionDetails, onPartToggled } = this.props;

        const hidePrice = di.profileManager.hidePrice()

        // create cards
        const sections = _.toPairs(_.groupBy(parts, "category")).map(entry => {

            // resolve category group / parts
            const category = entry[0];
            const parts = entry[1];
            let title;
            const section = {
                name: category,
                details: parts[0].details
            };
            let price = "";
            // calculate price
            if(!hidePrice){
                let modelSku = di.garage.bikeModel.sku;
                let basePrice = di.profileManager.localizePrice(di.catalogManager.priceForPart(parts[0].sku));
                let modelPrice = di.catalogManager.priceForPart(parts[0].sku, modelSku);
                price = {
                    base: basePrice,
                    model: modelPrice == undefined ? undefined : di.profileManager.localizePrice(modelPrice)
                };
            }
            let priceText = "";
            if (price) {
                if (price.model != undefined) {
                    priceText = di.localization.get("build.cosmetic.infoIconPrice", price.model, price.base);
                } else {
                    priceText = `+${price.base}`;
                    if(category.includes("panels")){
                        priceText = `+${price.base}`;
                    }
                    else{
                        priceText = `${price.base}`;
                    }
                }
            }
            // create panel + cards
            const cards = parts.map(p => {

                // capture title
                title = p.color;

                // render swatch
                return (
                    <ButtonBase key={p.id} onClick={() => onPartToggled(p, "cosmetics")}>

                        <Container flex style={styles.swatchWrap}>
                            <img style={styles.swatch}
                                src={di.assetManager.getImage(p.image.uri)} />
                            <Text style={styles.subtitle} bold>{title}</Text>
                            {
                                bike.has(p) &&
                                <Container style={styles.divider} />
                            }
                        </Container>
                    </ButtonBase>
                );
            });

            let containerWidth = "50%";
            let minWidth = 0;

            if (parts.length > 3 ) {
                containerWidth = "100%";
            } else if (parts.length === 3) {
                // minWidth = "75%";
                containerWidth = "100%"
            }
            let cardsWidth = cards.length * 160 + 150
            return (
                <Container flex key={category} style={{...styles.swatchBacking, maxWidth: containerWidth, minWidth: minWidth}}>
                    <Container flex style={{...styles.swatches, width: cardsWidth}} direction="row">

                        <Container style={styles.details}>
                            <Text style={styles.title}>{category}</Text>

                            <Text style={styles.price}>{priceText}</Text>
                        </Container>

                        <Container
                            flex
                            alignItems="center"
                            direction="row"
                            justify="space-between"
                            alignContent="space-between">
                            {cards}
                        </Container>

                        {/* Info Button */}
                        <InfoIcon style={styles.infoIconContainer} onPress={() => onSectionDetails(section)} />
                    </Container>
                </Container>
            );
        });
        // render view
        return (
            <ScrollableContainer style={styles.content}>
                <Container flex style={styles.container} direction="row">
                    {sections}
                </Container>
            </ScrollableContainer>
        );
    }
}

const styles = {
    container: {
    },
    content: {
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: "#000000d0",
        height: 162
    },
    details: {
        minWidth: 150,
        // width: 250
    },
    title: {
        color: "#fff"
    },
    subtitle: {
        color: "#fff",
        fontSize: 16,
        textAlign: 'center',
        minWidth: 125
    },
    swatchBacking: {
        backgroundColor: "transparent",
        paddingRight: 12,
        paddingLeft: 12,
        height: 126
    },
    swatches: {
        position: "relative",
        padding: 12,
        height: 126,
        backgroundColor: "#3c3c3c"
    },
    swatchWrap: {
        height: 42,
        marginRight: 36,
        marginBottom: 20,
        alignContent: "center",
        alignItems: "center",
        borderRadius: 21,
        minWidth: 124,
        overflow: "visible",
    },
    swatch: {
        width: 45,
        height: 45,
        alignContent: "center"
    },
    infoIconContainer: {
        position: "absolute",
        bottom: 4,
        left: 4,
        padding: 4,
        paddingTop: 12,
        paddingRight: 12
    },
    divider: {
        width: "100%",
        height: 1,
        backgroundColor: "#ffd200",
        border: "solid 1px #ffd200"
    },
    price: {
        color: "#cecece",
        fontSize: 12
    }
};


// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/CosmeticList.js